import { Component, Input, OnInit, output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, map, Observable, OperatorFunction, Subject } from 'rxjs';

@Component({
  selector: 'app-petplan-select-breed-modal',
  templateUrl: './petplan-select-breed-modal.component.html',
  styleUrl: './petplan-select-breed-modal.component.scss'
})
export class PetplanSelectBreedModalComponent implements OnInit{
  
  @Input('petName') public petName: string;
  @Input('breedNamesList') public breedNamesList: string[];
  @Input('petSpecie') public petSpecie: string;
  @Input('isSpaniel') public isSpaniel: boolean;

  selectedBreed: string = null;
  public title: string;

  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  constructor(public activeModal: NgbActiveModal) {}
  ngOnInit(): void {
    this.title = this.isSpaniel ? `To get 4 weeks free pet insurance from Petplan, please select the breed of spaniel ${this.petName} is most similar to.` : 
    `To get 4 weeks free pet insurance from Petplan, please select the ${this.petSpecie} breed ${this.petName} is most similar to.` 
  }

  searchBreed: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 1 ? this.breedNamesList
      : this.breedNamesList.filter(breed => 
          breed.toLowerCase().includes(term.toLowerCase())
        )
    )
  );

  formatter = (breed: string) => breed;

  onSubmit(): void {
    this.activeModal.close(this.selectedBreed);
  }
}
